import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import jobPosts from "../jobPosts.json";

const Career = () => {
  return (
    <Container className="career-page mt-5">
      <Row className="mb-4">
        <Col className="my-5 job-post career-intro">
          <h2 className="text-center">Careers at Ecorvi</h2>
          <p className="text-center">
            Explore the opportunities where you can build skills, ship real features, and grow with mentors.
          </p>
        </Col>
      </Row>
      <Row className="g-3 mb-5 justify-content-center">
        {jobPosts.map((job) => (
          <Col key={job.id} sm={12}>
            <div className="arrow-card">
              <div className="arrow-card-content">
                <h5 className="mb-2">{job.title}</h5>
                <Link to={`/career/${job.id}`} className="arrow-link">
                  View details
                </Link>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Career;
